import React, { useEffect, useState } from "react";

import Loader from "components/Loader";
import { useAnswerContext } from "contexts/answerContext";
import { useScopeProject } from "queries/projects";
import { isInProgress } from "reducers/projects";

const ScopeProject = ({ children }) => {
  const { record: project } = useAnswerContext();
  const { mutateAsync: scopeProject } = useScopeProject(project.id);
  const [isScoping, setIsScoping] = useState(false);
  const isScoped = !isInProgress(project);

  useEffect(() => {
    if (!isScoped && !isScoping) {
      setIsScoping(true);
      scopeProject();
    }
  }, [isScoped, isScoping, scopeProject]);

  useEffect(() => {
    if (isScoped) {
      setIsScoping(false);
    }
  }, [isScoped]);

  if (isScoped) {
    return children;
  }

  return <Loader />;
};

export default ScopeProject;
